import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/italy-regions.geojson";

const REGIONS = [
    { code: "Abruzzo", name: "Abruzzo" },
    { code: "Basilicata", name: "Basilicata" },
    { code: "Calabria", name: "Calabria" },
    { code: "Campania", name: "Campania" },
    { code: "Emilia-Romagna", name: "Emilia-Romagna" },
    { code: "Friuli Venezia Giulia", name: "Friuli Venezia Giulia" },
    { code: "Lazio", name: "Lazio" },
    { code: "Liguria", name: "Liguria" },
    { code: "Lombardia", name: "Lombardia" },
    { code: "Marche", name: "Marche" },
    { code: "Molise", name: "Molise" },
    { code: "Piemonte", name: "Piemonte" },
    { code: "Puglia", name: "Puglia" },
    { code: "Sardegna", name: "Sardegna" },
    { code: "Sicilia", name: "Sicilia" },
    { code: "Toscana", name: "Toscana" },
    { code: "Trentino-Alto Adige/Sudtirol", name: "Trentino-Alto Adige/Sudtirol" },
    { code: "Umbria", name: "Umbria" },
    { code: "Valle D'Aosta/Vallée D'Aoste", name: "Valle D'Aosta/Vallée D'Aoste" },
    { code: "Veneto", name: "Veneto" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const ItalyMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1900, center: [13, 42.5] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="italy"
            analyticsLocationType="italy"
            trackingLabel="Italy Map"
            storageKey="italy_map"
            title="🇮🇹 Italy Travel Map"
            subtitle="Click on Italian regions you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Regions"
            unitLabel="regions"
            captionUnit="Italian regions"
            share={{
                region: 'Italy',
                fileName: 'visited-italy-map.png',
                trackId: 'italy'
            }}
            renderMap={renderMap}
        />
    );
};

export default ItalyMapSection;
